<res-base-modal [modalTitle]="'Extract Office 365 Data'" [modalClass]="modalClass" [modalAutomationId]="automationId"
    [primaryButtonLabel]="'OK'" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [isPrimaryBtnEnabled]="!isBusy && okEnabled()" [secondaryButtonLabel]="'Cancel'" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [modalHelpIndex]="modalHelpIndex" [modalHasVariableHeight]="true">

    <div>
        <div class="modal-row input-label-row">
            <label>Document Processing Timeout:</label>
            <input #docProcessingTimeout type="text" maxlength="3" (keypress)="restrictNumeric($event)"
                (blur)="parseNumeric('documentExtractOffice365DataTimeout', 3, 180)"
                [(ngModel)]="documentExtractOffice365DataTimeout"
                [data-automation-id]="automationId + '-document-processing-timeout-input'" title="Enter: 3 - 180"
                class="error-popover" containerClass="info" container="body" [popover]="errorPopoverTemplate"
                triggers="" #docRangeInfoPopover="bs-popover" placement="top" />
            <ng-template #errorPopoverTemplate>
                <span
                    data-automation-id="extract-office-365-data-modal-doc-processing-timeout-info-label">{{docRangeInfoText}}</span>
                <i class="fa fa-close" (click)="docRangeInfoPopover.hide()"></i>
            </ng-template>
            <label>minutes</label>
        </div>
        <div class="modal-row">
            <label requiredAsterisk>Office 365 Connector: </label>
            <select [(ngModel)]="selectedOffice365ConnectorHandle"
                [attr.data-automation-id]="automationId + '-office-365-connector-option'" class="expand">
                <option [value]=''></option>
                <optgroup label="MS Exchange (Office 365):">
                    <option *ngFor="let connector of office365ExchangeConnectors | values" [value]="connector.handle">
                        {{connector.name}}</option>
                </optgroup>
                <optgroup label="MS SharePoint (Office 365 Public / Private Sites):">
                    <option *ngFor="let connector of office365SharePointConnectors | values" [value]="connector.handle">
                        {{connector.name}}</option>
                </optgroup>
            </select>
        </div>
    </div>
</res-base-modal>